import styles from "./local-nav.style.scss?raw";

export class LocalNavComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Inject styles into the document head
        if (!document.getElementById('local-nav-styles')) {
            const styleElement = document.createElement('style');
            styleElement.id = 'local-nav-styles';
            styleElement.textContent = styles;
            document.head.appendChild(styleElement);
        }

        this.innerHTML = `
            <nav>
                <h1>The Big Whale</h1>
                <div class="nav-links-container">
                    <tbw-global-search-opener></tbw-global-search-opener>
                    <tbw-dark-mode-switcher></tbw-dark-mode-switcher>
                    <div id="navbarV3LoginPlaceholderEl"></div>
                    <button id="auth-btn">Trigger authChange Event</button>
                </div>
                <ul>
                    <li ><a class="nav-link" href="/">Home</a></li>
                    <li ><a class="nav-link" href="/src/tests/newsletter.html">Newsletters</a></li>
                    <li ><a class="nav-link" href="/src/tests/token-data.html">Token Data</a></li>
                    <li ><a class="nav-link" href="/src/tests/asset-screener.html">Asset Screener</a></li>
                    <li ><a class="nav-link" href="/src/tests/homepage.html">Homepage</a></li>
                    <li ><a class="nav-link" href="/src/tests/payments.html">Payments</a></li>
                    <li ><a class="nav-link" href="/src/tests/test-from-deployed.html">FROM DEPLOYED</a></li>
                    <li ><a class="nav-link" href="/src/tests/charts-tests.html">Charts Tests</a></li>
                    <li ><a class="nav-link" href="/src/tests/numbers-tests.html">Numbers Tests</a></li>
                    <li ><a class="nav-link" href="/src/tests/news-tests.html">News Tests</a></li>
                    <li ><a class="nav-link" href="/src/tests/bubbles-tests.html">Bubbles Test</a></li>
                    <li ><a class="nav-link" href="/src/tests/pie-chart-test.html">Pie Chart Test</a></li>
                    <li ><a class="nav-link" href="/src/tests/table-chart-test.html">Table Chart Test</a></li>
                </ul>
            </nav>
        `;

        // Set active state based on current page
        this.setActiveNavItem();
        this.createAuthTriggerButton();
    }

    createAuthTriggerButton(): void {
        const authBtn = this.querySelector('#auth-btn') as HTMLButtonElement;
        authBtn?.addEventListener('click', function (e) {
          console.log('click auth btn')
          const customEvent = new CustomEvent('authChange', {
            detail: { authenticated: true },
            bubbles: true,
            cancelable: true
          });
        
          document.dispatchEvent(customEvent);
        });
    }

    private setActiveNavItem(): void {
        const currentPath = window.location.pathname;
        const aList = this.querySelectorAll('a');
        
        aList.forEach(a => {
            const href = a.getAttribute('href');
            if (href) {
                // Handle home page case
                if (currentPath === '/' && href === '/') {
                    a.classList.add('active');
                }
                // Handle other pages
                else if (currentPath.includes(href) && href !== '/') {
                    a.classList.add('active');
                }
            }
        });
    }
}